// import { get_Token } from "util/Helper";
import axiosInstance from "../../../../axios";

// Get
export const getCategoryService = async ({ searchKey }) => {
  try {
    const response = await axiosInstance.get(
      `/courses/category?name=${searchKey}`
    );
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Add
export const addCategoryService = async (payload) => {
  try {
    const response = await axiosInstance.post(`/courses/category`, payload);
    console.log("add cat res", response?.data);
    return {
      isSuccess:
        response?.data?.statusCode === 201 || response?.data?.statusCode === 200,
      message: response?.data?.message,
    };
  } catch (e) {
    return { error: e?.response?.message };
  }
};
// Update
export const updateCategoryService = async (payload, id) => {
  try {
    const response = await axiosInstance.patch(
      `/courses/category/${id}`,
      payload
    );
    console.log("update cat res", response?.data);
    return {
      isSuccess:
        response?.data?.statusCode === 201 || response?.data?.statusCode === 200,
      message: response?.data?.message,
    };
  } catch (e) {
    return { error: e?.response?.message };
  }
};

//Delete
export const deleteCategoryService = async (id = "") => {
  try {
    const { status, message } = await axiosInstance.delete(
      `/courses/category/${id}`,
      null
    );

    return { isSuccess: status === 200, message };
  } catch (e) {
    return {
      error: e?.response?.data || e?.message,
    };
  }
};

// Get SubAdmin
export const getSubAdminUserService = async (payload) => {
  try {
    console.log("oho", payload);
    const response = await axiosInstance.get(
      `/auth/list-sub-admin?pageLength=${payload.currentPageLimit}&pageNo=${payload.currentPage}&name=${payload.searchKey}`
    );
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Get Courses of a category
export const getCoursesOfCategoryService = async (data) => {
  try {
    console.log("hello ji service", data);
    const response = await axiosInstance.get(
      `/courses/admin/category/${data?.payload}?name=${data?.searchCourseKey}`
    );
    console.log(response, "ohio");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
